module.exports = __webpack_public_path__ + "img/inst2.fb7a692d.png";